export default __webpack_public_path__ + "static/media/AMZN_FR_SH.d8912e14.svg";